import React from 'react'
import PropTypes from 'prop-types'

import { DismissibleDialog } from '@scoir/modals'

import AudienceDetails from './AudienceDetails'
import MessageDetails from './MessageDetails'

const { Body, Footer } = DismissibleDialog

const { CloseButton } = Footer

const PreviewModal = ({ outreachItem, show, onClose }) => (
  <DismissibleDialog
    open={show}
    scroll="paper"
    aria-label="View Outreach Message"
    headerText="Message Preview"
    onClose={onClose}
  >
    <Body
      withBackgroundColor
      multiSection
    >
      <AudienceDetails message={outreachItem} />
      <MessageDetails message={outreachItem} />
    </Body>
    <Footer>
      <CloseButton variant="contained">Close</CloseButton>
    </Footer>
  </DismissibleDialog>
)

PreviewModal.propTypes = {
  outreachItem: PropTypes.object,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default PreviewModal
